import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Tag,
  Layer,
  Accordion,
  AccordionPanel,
  Spinner,
  CardFooter,
  Tip,
} from "grommet";
import {
  Hpe,
  More,
  MoreVertical,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Gallery,
  Document,
  Inspect,
  Close,
  Link,
  Copy,
  CaretDown,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import AppHeader from "./AppHeader";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
  logAccess,
  APIServerURL,
  debugLog,
  UIServerURL,
  callApiText,
} from "./GlobalSettings";
import LaunchLiveDemo from "./LaunchLiveDemo";
import ScheduleDemoOverlayA from "./ScheduleDemoOverlayA";
import ShareContentMessage from "./ShareContentMessage";
//import { Icon } from "@material-ui/core";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import { isThisHour } from "date-fns";
import {
  CollectionsOutlined,
  FormatColorResetTwoTone,
  MoreVert,
} from "@material-ui/icons";
import DocumentHandler from "./DocumenHandler";
import VideoHandler from "./VideoHandler";

class ContentDetailViewCard extends Component {
  constructor(props) {
    super(props);
    this._HPEOnBackClick = this._HPEOnBackClick.bind(this);
    this.sanitizedContentDescription =
      this.sanitizedContentDescription.bind(this);
    this.loadDemoData = this.loadDemoData.bind(this);
    this._ShowLaunchLiveDemo = this._ShowLaunchLiveDemo.bind(this);
    this._ShowScheduleViews = this._ShowScheduleViews.bind(this);
    this._HideLaunchLiveDemo = this._HideLaunchLiveDemo.bind(this);
    this._HideScheduleDemoScreen = this._HideScheduleDemoScreen.bind(this);
    this._downloadPdf = this._downloadPdf.bind(this);
    this._openPresentation = this._openPresentation.bind(this);
    this.OnShare = this.OnShare.bind(this);
    this._hideShareContentPopUp = this._hideShareContentPopUp.bind(this);
    this.addToFavReqHandler = this.addToFavReqHandler.bind(this);
    this._handleDocumentView = this._handleDocumentView.bind(this);
    this._CloseOverlayDoc = this._CloseOverlayDoc.bind(this);
    this._downloadPdfForDocContent = this._downloadPdfForDocContent.bind(this);
    this._ShowVideo = this._ShowVideo.bind(this);
    this._CloseVideo = this._CloseVideo.bind(this);
    this._downloadVideo = this._downloadVideo.bind(this);
    // this._downloadPdf = this._downloadPdf.bind(this);

    this.state = {
      DemoData: this.props._demoData,
      bIsLaunch: false,
      bIsrefreshing: true,
      bLaunchLiveDemoScreen: false,
      bShowScheduleDemoOverlayA: false,
      bIsShared: false,
      SharedUrl: undefined,
      isFavourite: this.props._demoData.Content_IsFavorite,
      bLoadingFavUnFavHit: false,
      isFavUnFavdone: false,
      bShowDoc: false,
      bShowVideo: false,
      bDownloadVideo: false,
      UserInfo: auth.getUserInfo(),
      /*  bIsHavingDemoGuide: false,
      bIsScheduleEnabled: false, */
    };
  }

  componentDidMount() {
    if (this.props._demoData.Content_Type == "Physical") {
      this.loadDemoData();
      this._demoInterval = setInterval(() => {
        console.log("Interval started!");
        this.loadDemoData();
      }, OnDemandRefreshInterval);
    }
  }

  componentWillUnmount() {
    if (this.props._demoData.Content_Type == "Physical") {
      clearInterval(this._demoInterval);
    }
  }

  _downloadVideo(contentRecord) {
    //event.stopPropagation();
    var endpoint =
      "/MultimediaContent/GetMMStreamURL/" + contentRecord.Content_ID;
    let token = auth.getToken();
    callApiText(endpoint, token).then((data) => {
      debugLog(" BC URL:");
      debugLog(data);
      if (data !== undefined) {
        var elem = window.document.createElement("a");
        elem.href = data;
        elem.target = "_blank";
        elem.download =
          contentRecord.Content_Title + "." + contentRecord.Content_Format;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
      //this.showSnack(data);
      //this.props.removeRatings(index);
    });
    auth.verifyToken(true);
    logAccess(
      contentRecord.Content_ID,
      contentRecord.Content_Type,
      "DownloadVideo",
      this.props.calledBy,
      token,
    );
  }

  _ShowVideo() {
    this.setState({ bShowVideo: true });
  }

  _CloseVideo() {
    this.setState({ bShowVideo: false });
  }

  _handleDocumentView() {
    this.setState({ bShowDoc: true });
  }

  _CloseOverlayDoc() {
    this.setState({ bShowDoc: false });
  }

  addToFavReqHandler(contentRecord) {
    console.log("Favorite event fired!!");
    // event.stopPropagation();
    var endpoint = "/AllContent/AddorRemoveFavorites";
    var postData = {
      Favorite_ID: null,
      ContentId: contentRecord.Content_ID,
      Action_Type: contentRecord.Content_IsFavorite ? "Delete" : "Insert",
      Content_Type: contentRecord.Content_Type,
    };
    let token = auth.getToken();
    this.setState({ bLoadingFavUnFavHit: true });
    callApiPostJson(endpoint, postData, token).then((data) => {
      //console.log('EventAvailableEventTimes data:', data);
      if (data.Action_Type) {
        /*//This code reloads just the favorites piece.
             this.reloadFavorites();*/
        /*if(this.state.currentSearchObject)
             this._onSearchTextChange(this.state.currentSearchObject, this.state.currentSelectedSuggestion);
             else this.performInitialSearch();*/
        //contentRecord.Content_IsFavorite = true; //this refreshes contentrecord on display
        if (data.Action_Type === "Insert") {
          this.setState({
            isFavourite: true,
            bLoadingFavUnFavHit: false,
            isFavUnFavdone: true,
          });
          /*  contentRecord.Content_IsFavorite = true;
                this.showSnack("Content added to My Favorites. Reloading..."); */
        } else {
          this.setState({
            isFavourite: false,
            bLoadingFavUnFavHit: false,
            isFavUnFavdone: true,
          });
          /*                 contentRecord.Content_IsFavorite = false;
                this.showSnack("Content removed from My Favorites.  Reloading..."); */
        }
      } else {
        this.setState({ bLoadingFavUnFavHit: false });
      }
    });
  }

  _hideShareContentPopUp() {
    this.setState({ SharedUrl: undefined, bIsShared: false });
    // this.props.hide();
  }

  OnShare() {
    if (this.props._demoData.Content_Type == "Physical") {
      var srchDemoId = "";
      if (this.props._demoData.Content_Link) {
        var splitVals = this.props._demoData.Content_Link.split("-");
        srchDemoId = splitVals[1].trim();
      }

      var lnk =
        UIServerURL +
        "?demoid=" +
        //"?name=" +
        // encodeURIComponent(this.props._demoData.Content_Title);
        srchDemoId;
      this.setState({ SharedUrl: lnk, bIsShared: true });
    }
    if (
      this.props._demoData.Content_Type == "Multimedia" ||
      this.props._demoData.Content_Type == "Document"
    ) {
      var lnk =
        UIServerURL +
        "?name=" +
        encodeURIComponent(this.props._demoData.Content_Title);
      this.setState({ SharedUrl: lnk, bIsShared: true });
    }
  }

  _downloadPdfForDocContent(contentRecord, event) {
    event.stopPropagation();
    var endpoint = "/DocContent/GetDocAccessToken/" + contentRecord.Content_ID;
    let token = auth.getToken();

    callApiGetJson(endpoint, token).then((data) => {
      if (data !== undefined) {
        debugLog(data);
        var elem = window.document.createElement("a");
        elem.href = APIServerURL + "/DocContent/GetDocByToken/" + data.Token;
        elem.target = "_blank";
        elem.download =
          contentRecord.Content_Title + "." + contentRecord.Content_Format;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    });

    //this just refreshes the user token if necessary
    auth.verifyToken(true);
    logAccess(
      contentRecord.Content_ID,
      contentRecord.Content_Type,
      "DownloadDocument",
      this.props.calledBy,
      token,
    );
  }

  _openPresentation() {
    window.open(this.props._demoData.RefLink, "_blank");
  }

  _downloadPdf(dmeoguideId, event) {
    event.stopPropagation();
    var endpoint = "/DocContent/GetDocAccessToken/" + dmeoguideId; // contentRecord.Content_ID;
    let token = auth.getToken();

    callApiGetJson(endpoint, token).then((data) => {
      if (data !== undefined) {
        debugLog(data);
        var elem = window.document.createElement("a");
        elem.href = APIServerURL + "/DocContent/GetDocByToken/" + data.Token;
        elem.target = "_blank";
        elem.download = dmeoguideId + "." + "pdf";
        //contentRecord.Content_Title + "." + contentRecord.Content_Format;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    });

    //this just refreshes the user token if necessary
    auth.verifyToken(true);
    logAccess(
      dmeoguideId,
      //this.props._demoData.Content_ID,
      "Document",
      // this.props._demoData.Content_Type,
      "DemoGuideDownloaded",
      this.props.calledBy,
      token,
    );
  }

  _ShowLaunchLiveDemo() {
    this.setState({ bLaunchLiveDemoScreen: true });
    //this.props.hide();
  }

  _ShowScheduleViews() {
    console.log("Show Schedule View Fired !! ");
    this.setState({ bShowScheduleDemoOverlayA: true });
  }

  _HideLaunchLiveDemo() {
    this.setState({ bLaunchLiveDemoScreen: false });
    //this.props.hide();
  }

  _HideScheduleDemoScreen() {
    this.setState({ bShowScheduleDemoOverlayA: false });
    this.props.hide();
  }

  _HPEOnBackClick() {
    // this.props.history.push("/");
  }

  loadDemoData() {
    var endpoint = "/AllContent/GetPhysicalContents_Refreshed_Published";
    let token = auth.getToken();
    this.setState({ bIsrefreshing: true });
    //var that=this;
    //if (this.state.UserActions.Content.ScheduleEvent) {
    callApiGetJson(endpoint, token).then((data) => {
      //console.log(data);
      var demoSearchData = this.state.DemoData;
      if (demoSearchData !== undefined) {
        //demoSearchData = demoSearchData.map(function (obj, index) {
        //console.log(obj);
        var currentIndex = 0;
        data.forEach(function (item, itemIndex) {
          if (item.Content_ID === demoSearchData.Content_ID) {
            currentIndex = itemIndex;
          }
        });
        demoSearchData.Is_DemoReady = data[currentIndex].Is_DemoReady;
        demoSearchData.Is_Launchable = data[currentIndex].Is_Launchable;
        demoSearchData.Is_Schedulable = data[currentIndex].Is_Schedulable;
        demoSearchData.Is_AllDown = data[currentIndex].Is_AllDown;
        demoSearchData.Content_Environments =
          data[currentIndex].Content_Environments;
        demoSearchData.PhyContent_TA_OKTA_TemplateName =
          data[currentIndex].PhyContent_TA_OKTA_TemplateName;
        //demoSearchData.Content_IsFavorite =
        //data[currentIndex].Content_IsFavorite;

        /*         if (data[currentIndex].DemoGuid_DocID) {
          this.setState({ bIsHavingDemoGuide: true });
        } */

        this.setState({
          DemoData: demoSearchData,
          bIsrefreshing: false,
          //isFavourite: demoSearchData.Content_IsFavorite,
        });
      }
    });
  }

  sanitizedContentDescription(description) {
    return <div dangerouslySetInnerHTML={{ __html: description }} />;
  }

  render() {
    var demo_Data = undefined;
    demo_Data = this.state.DemoData
      ? this.state.DemoData
      : this.props._demoData;

    var BShowDocument = this.state.bShowDoc;

    var bVideoOverlay = this.state.bShowVideo;
    var bVideoDownload = this.state.bDownloadVideo;

    var UInfo = this.state.UserInfo ? this.state.UserInfo : undefined;

    console.log("Content coming from List is", this.props._demoData);
    var Cont_Prods = "";

    if (this.state.DemoData.Content_Products) {
      this.state.DemoData.Content_Products.map((item) => {
        if (Cont_Prods !== "") {
          Cont_Prods = Cont_Prods + "," + item.ProductName;
        } else {
          Cont_Prods = item.ProductName;
        }
      });
    }

    var IsHack = undefined;
    var IsTMEIndi = undefined;
    var IsTMECR = undefined;
    var IsTA_OKTA = undefined;
    var IsGLApp_Type = undefined;
    var isOpsRampApp_Type = undefined;
    var isMistAppType = undefined;

    IsHack =
      this.state.DemoData.Content_Environments &&
      this.state.DemoData.Content_Environments[0].EnvironmentType.EvnType ===
        "HACKSHACK"
        ? true
        : false;

    IsTA_OKTA =
      this.state.DemoData.Content_Environments &&
      this.state.DemoData.Content_Environments[0].EnvironmentType.EvnType ===
        "TA_OKTA"
        ? true
        : false;

    IsGLApp_Type =
      this.state.DemoData.Content_Environments &&
      this.state.DemoData.Content_Environments[0].EnvironmentType.EvnType ===
        "GL_APP"
        ? true
        : false;

    isOpsRampApp_Type =
      this.state.DemoData.Content_Environments &&
      this.state.DemoData.Content_Environments[0].EnvironmentType.EvnType ===
        "OPSRAMP_APP"
        ? true
        : false;

    isMistAppType =
      this.state.DemoData.Content_Environments &&
      this.state.DemoData.Content_Environments[0].EnvironmentType.EvnType ===
        "MIST_APP"
        ? true
        : false;

    IsTMEIndi =
      this.state.DemoData.Content_Environments &&
      this.state.DemoData.Content_Environments[0].EnvironmentType.EvnType ===
        "TME_INDIVIDUAL"
        ? true
        : false;

    IsTMECR =
      this.state.DemoData.Content_Environments &&
      this.state.DemoData.Content_Environments[0].EnvironmentType.EvnType ===
        "TME_CLASSROOM"
        ? true
        : false;

    console.log("Is this Demo HackShack Type ", IsHack);
    console.log("Is this Demo TME Individual Type ", IsTMEIndi);
    console.log("Is this Demo TME Classroon Type ", IsTMECR);
    console.log("Is this TA_OKTA Type ", IsTA_OKTA);
    console.log("Is this GL_App Type Demo ", IsGLApp_Type);
    console.log("Is this OpsRamp_App Type Demo ", isOpsRampApp_Type);
    console.log("Is this Mist App Type Demo ", isMistAppType);

    var bIsHavingDemoGuide = false;
    var bIsHavingPresentationLink = false;

    bIsHavingDemoGuide = this.state.DemoData.DemoGuid_DocID ? true : false;
    bIsHavingPresentationLink =
      this.props._demoData.RefLink &&
      this.props._demoData.RefLink != undefined &&
      this.props._demoData.RefLink.length > 10
        ? true
        : false;
    console.log("**Is Having Demo Guide", bIsHavingDemoGuide);
    console.log("**Is Having Presentation Link", bIsHavingPresentationLink);

    var bLaunchLiveDemoScreen = this.state.bLaunchLiveDemoScreen;
    var bLaunchScheduleDemoScreem = this.state.bShowScheduleDemoOverlayA;

    var bIsTobeShared = this.state.bIsShared;
    var SharedLnk = this.state.SharedUrl;

    var spinnercontent = "";
    if (this.state.bLoadingFavUnFavHit) {
      spinnercontent = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner size="small" />
            <Text size="small">Updating your Favourites...</Text>
          </Box>
        </Layer>
      );
    }

    console.log(
      "Right now SChedule View Show State Status is ",
      bLaunchScheduleDemoScreem,
    );

    console.log("Content Products are ", Cont_Prods);

    console.log("Prop Data from Demo Detail is ", this.props._demoData);
    console.log("State Data from Demo Detail is ", demo_Data);

    var IsCont_Favorite = this.state.isFavourite;

    var Fav_UnFav_Done = this.state.isFavUnFavdone;

    let substrDescr = null;

    if (demo_Data != undefined) {
      substrDescr = demo_Data.Content_Description.substring(0, 200);
      // substrDescr = substrDescr + "...";
    }

    //console.log("this.state.listData: ", this.state.listData);
    return (
      <Layer
        full="vertical"
        fill="vertical"
        position="right"
        margin={{ top: "medium", bottom: "small" }}
      >
        {spinnercontent}
        {bVideoOverlay && (
          <VideoHandler
            VideoContentRecord={this.props._demoData}
            hide={this._CloseVideo}
            UserType={UInfo.UsertypeID}
            calledBy={this.props.calledBy}
          />
        )}
        {BShowDocument && (
          <DocumentHandler
            DocumentContentRecord={this.props._demoData}
            Document_ID={undefined}
            hide={this._CloseOverlayDoc}
            calledBy={this.props.calledBy}
          />
        )}
        {/* <Card justify="start" width="large" gap="xsmall" background="light-1">
          <CardHeader> */}

        <Card
          direction="column"
          // border={{ style: "dashed" }}
          margin={{ top: "medium" }}
          fill="vertical"
        >
          <CardHeader
            align="center"
            direction="column"
            flex={false}
            justify="between"
            gap="medium"
            pad="small"
          >
            <Box
              align="end"
              justify="end"
              margin={{ top: "small" }}
              direction="row"
            >
              <Button
                icon={<Close />}
                onClick={this.props.hide}
                secondary={true}
                color="brand"
                // plain
              />
            </Box>
            <Box
              align="center"
              justify="between"
              direction="row-responsive"
              fill="horizontal"
            >
              <Text color="black" weight="bold">
                {demo_Data.Content_Title}
              </Text>
              {IsCont_Favorite ? (
                <Button
                  // icon={<FavoriteIcon style={{ color: "red" }} />}
                  icon={
                    <FavoriteIcon color="secondary" style={{ fontSize: 40 }} />
                  }
                  // hoverIndicator
                  active={false}
                  disabled={Fav_UnFav_Done}
                  reverse={false}
                  secondary={false}
                  //primary
                  onClick={(contentRecord) => {
                    this.addToFavReqHandler(demo_Data);
                  }}
                />
              ) : (
                <Button
                  icon={
                    <FavoriteBorderIcon
                      style={{ fontSize: 40, color: "green" }}
                    />
                  }
                  // hoverIndicator
                  active={false}
                  disabled={Fav_UnFav_Done}
                  reverse={false}
                  secondary={false}
                  onClick={(contentRecord) => {
                    this.addToFavReqHandler(demo_Data);
                  }}
                  //primary
                />
              )}
            </Box>
            {/*             <Box
              align="stretch"
              justify="between"
              direction="row"
              pad="xsmall"
              fill="horizontal"
            >
              <Text>LIVE</Text>
              <Text>EXPERT</Text>
            </Box> */}
          </CardHeader>
          <CardBody pad="medium">
            <Box
              // pad="small"
              // gap="small"
              margin={{ top: "small", bottom: "small" }}
              height="medium"
              // width={{ max: "large" }}
              // height={{ max: "large" }}
              overflow={{ vertical: "scroll", horizontal: "hidden" }}
              // round="small"
              // background="background-front"
              border={true}
              responsive={false}
            >
              <Paragraph
                //  overflow={{ horizontal: "hidden", vertical: "scroll" }}
                size="medium"
                // fill="vertical"
                // maxLines={4}
                margin={{
                  left: "small",
                  top: "small",
                  bottom: "small",
                  right: "small",
                }}
                // fill="vertical"
              >
                {this.sanitizedContentDescription(
                  demo_Data.Content_Description,
                )}
              </Paragraph>
            </Box>
          </CardBody>
          <CardFooter
            align="stretch"
            direction="column"
            flex={false}
            justify="between"
            gap="medium"
            pad="xsmall"
          >
            <Box align="center" justify="between" direction="row-responsive">
              {demo_Data.Content_Type == "Document" && (
                <Button
                  label="View"
                  primary={true}
                  color="brand"
                  icon={<Inspect />}
                  secondary
                  onClick={this._handleDocumentView}
                />
              )}
              {demo_Data.Content_Type == "Document" && (
                <Button
                  label="Download"
                  icon={<Download />}
                  secondary={false}
                  color="brand"
                  primary={true}
                  onClick={(event) => {
                    this._downloadPdfForDocContent(demo_Data, event);
                  }}
                />
              )}
              {demo_Data.Content_Type == "Multimedia" && (
                <Button
                  label="Play"
                  primary={true}
                  color="brand"
                  icon={<Play />}
                  secondary={false}
                  // disabled={true}
                  onClick={this._ShowVideo}
                />
              )}
              {demo_Data.Content_Type == "Multimedia" &&
                demo_Data.Content_BrightcoveID && (
                  <Button
                    label="Download"
                    icon={<Download />}
                    secondary={true}
                    color="brand"
                    primary={false}
                    // secondary={true}
                    onClick={(contentRecord) => {
                      this._downloadVideo(this.props._demoData);
                    }}
                    //disabled={true}
                  />
                )}
              {demo_Data.Content_Type == "Physical" &&
                demo_Data.Is_Schedulable &&
                !demo_Data.Is_AllDown && (
                  <Button
                    label="schedule"
                    primary={true}
                    color="brand"
                    margin={{ left: "small", right: "small" }}
                    icon={<ScheduleNew />}
                    secondary={false}
                    // disabled={true}
                    onClick={this._ShowScheduleViews}
                  />
                )}
              {/*               {demo_Data.Content_Type == "Physical" &&
                (!demo_Data.Is_Schedulable || demo_Data.Is_AllDown) && (
                  <Button
                    label="schedule"
                    primary={false}
                    // color="brand"
                    icon={<ScheduleNew />}
                    secondary={true}
                    disabled={true}
                  />
                )} */}

              {demo_Data.Content_Type == "Physical" &&
                demo_Data.Is_DemoReady &&
                demo_Data.Is_Launchable && (
                  <Button
                    label="OnDemand"
                    primary={true}
                    color="brand"
                    icon={<Console />}
                    margin={{ left: "small", right: "small" }}
                    secondary
                    disabled={this.state.bIsrefreshing}
                    onClick={this._ShowLaunchLiveDemo}
                  />
                )}

              {demo_Data.Content_Type == "Physical" &&
                (!demo_Data.Is_DemoReady || !demo_Data.Is_Launchable) && (
                  <Button
                    label={
                      this.state.bIsrefreshing ? (
                        <Box
                          direction="row"
                          gap="small"
                          justify="center"
                          align="center"
                        >
                          <Spinner size="small" color="brand" />{" "}
                          <Text>Refreshing..</Text>
                        </Box>
                      ) : (
                        "OnDemand"
                      )
                    }
                    primary={false}
                    // color="brand"
                    icon={<Console />}
                    disabled={true}
                    secondary={true}
                  />
                )}
            </Box>
            <Box align="center" justify="between" direction="row-responsive">
              {this.props._demoData.Content_Type == "Physical" &&
                bIsHavingPresentationLink && (
                  <Button
                    //a11yTitle="Settings"
                    label="View Presentation"
                    icon={<Gallery />}
                    primary={false}
                    margin={{ left: "small", right: "small" }}
                    color="brand"
                    secondary={true}
                    // badge={
                    //   <Box
                    //     background="status-critical"
                    //     pad="xsmall"
                    //     round="xsmall"
                    //   >
                    //     <Gallery size="small" />
                    //   </Box>
                    // }
                    onClick={this._openPresentation}
                    //disabled={true}
                  />
                )}
              {this.props._demoData.Content_Type == "Physical" &&
                bIsHavingDemoGuide && (
                  <Button
                    label="Demo Guide"
                    icon={<DocumentPdf />}
                    primary={false}
                    margin={{ left: "small", right: "small" }}
                    //color="brand"
                    secondary={true}
                    onClick={(event) =>
                      this._downloadPdf(demo_Data.DemoGuid_DocID, event)
                    }
                    //disabled={true}
                  />
                )}
              {/*  {this.props._demoData.Content_Type == "Physical" &&
                !bIsHavingDemoGuide && (
                  <Button
                    label="Demo Guide"
                    primary={false}
                    //color="brand"
                    icon={<DocumentPdf />}
                    secondary={true}
                    disabled={true}
                  />
                )} */}
              <Button
                label="CopyURL"
                icon={<Link />}
                margin={{ left: "small", right: "small" }}
                primary={false}
                color="brand"
                secondary={true}
                onClick={this.OnShare}
              />
            </Box>
            <Box
              align="stretch"
              justify="start"
              gap="none"
              direction="column"
              margin="small"
              border={{ style: "dashed" }}
            >
              <Box
                align="center"
                justify="between"
                direction="row"
                gap="xsmall"
              >
                <Text size="small">Last Updated</Text>
                <Text size="small" textAlign="end">
                  {demo_Data.Content_ModifiedDate
                    ? new Date(demo_Data.Content_ModifiedDate).toString()
                    : new Date(demo_Data.Content_CreatedDate).toString()}
                </Text>
              </Box>
              <Box
                align="center"
                justify="between"
                direction="row"
                gap="xsmall"
              >
                <Text size="small">Author</Text>
                <Text size="small" textAlign="end">
                  {demo_Data.Content_Author}
                </Text>
              </Box>
              {this.props._demoData.Content_Type == "Physical" && (
                <Box
                  align="center"
                  justify="between"
                  direction="row"
                  gap="xsmall"
                >
                  <Text size="small">DemoID</Text>
                  <Text size="small" textAlign="end">
                    {demo_Data.Content_Link}
                  </Text>
                </Box>
              )}
              {/*              <Box
                align="stretch"
                justify="between"
                direction="row"
                gap="small"
              >
                <Text size="small">Keywords</Text>
                <Text size="small" textAlign="end">
                  dfhqjf, fsf,sqf,sdf,q,f,
                </Text>
              </Box> */}
              <Box
                align="center"
                justify="between"
                direction="row"
                gap="xsmall"
              >
                <Text size="small">Products</Text>
                <Text size="small" textAlign="end">
                  {Cont_Prods}
                </Text>
              </Box>
            </Box>
          </CardFooter>
        </Card>
        {bLaunchLiveDemoScreen && (
          <LaunchLiveDemo
            demo={demo_Data}
            Is_Hackshack={IsHack}
            Is_TMEIndi={IsTMEIndi}
            Is_TAOKTA={IsTA_OKTA}
            Is_GLApp={IsGLApp_Type}
            Is_OpsRampApp={isOpsRampApp_Type}
            Is_MistApp={isMistAppType}
            hide={this._HideLaunchLiveDemo}
            calledBy={this.props.calledBy}
          />
        )}
        {bLaunchScheduleDemoScreem && (
          <ScheduleDemoOverlayA
            demo={demo_Data}
            Is_TMECR={IsTMECR}
            hide={this._HideScheduleDemoScreen}
            calledBy={this.props.calledBy}
          />
        )}
        {bIsTobeShared && SharedLnk && (
          <ShareContentMessage
            url={SharedLnk}
            hide={this._hideShareContentPopUp}
          />
        )}
      </Layer>
    );
  }
}

export default ContentDetailViewCard;
